import React, { useContext, useCallback } from 'react';
import { DropdownStateContext } from '../DropdownStateManager';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
// A very simple toggle button implementation - this should cover 99% of use cases
const BasicDropdownToggle = ({ children , tabIndex , className , onClick , biData , onOpenBiData =biData , onCloseBiData =biData , innerRef , dataHook , 'aria-label': ariaLabel , 'aria-owns': ariaOwns  })=>{
    const { isOpen , setToggleRef  } = useContext(DropdownStateContext);
    const setRefs = useCallback((node)=>{
        setToggleRef(node);
        innerRef && innerRef(node);
    }, [
        innerRef,
        setToggleRef
    ]);
    return /*#__PURE__*/ React.createElement(BiDiv, {
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0,
        className: className,
        onClick: onClick,
        biData: isOpen ? onCloseBiData : onOpenBiData,
        innerRef: setRefs,
        role: "button",
        "aria-haspopup": "listbox",
        "aria-expanded": isOpen,
        "data-hook": dataHook,
        "aria-label": ariaLabel,
        "aria-owns": ariaOwns
    }, children);
};
BasicDropdownToggle.displayName = 'BasicDropdownToggle';
export default BasicDropdownToggle;
